/*
  Cantidades que no son plata: galones, sobre todo.

  POR QUÉ EXISTE. El mismo tanqueo se leía distinto según la pantalla —12, 12,3 o
  12,28— porque cada una decidió por su cuenta cuántos decimales pintar: ocho
  `.toFixed(1)` sueltos repartidos en varios repos, un `Math.round` y un `Intl` con
  dos decimales. En ESTE repo no hay helper compartido de ningún tipo —tampoco para
  plata: cada pantalla llama `toLocaleString('es-CO')` por su cuenta—, así que este
  es el primero.

  El caso que lo destapó: un operario registró **12,28 galones** en UCER FUELS y en
  el portal y en el WhatsApp le salió **12,3**. El dato estaba bien guardado
  —`discounts.quantity` es `NUMERIC(10,2)` y tenía 12.28 exacto— y la plata también.

  El daño no era la centésima perdida, era que los números dejaban de cuadrar:
  mostrado como 12,3 sobre un total de $135.080, quien divide ve $10.982 el galón en
  vez de los $11.000 pactados.

  DOS DECIMALES, NI UNO MÁS NI UNO MENOS: es lo que la base puede guardar.

  SIEMPRE LOS DOS, también en los redondos: `12` se muestra `12,00`. La primera
  versión (11/09/2026) no ponía mínimo; se corrigió el 13/09 a pedido.

  Este repo no tiene runner de tests, así que la regla vive probada en
  `retri-api/tests/formatQuantity.test.js` y en los otros repos que sí lo tienen
  (retri-website, retri-internal-app y retri-app).
  Si cambia acá, tiene que cambiar allá.
*/
export const formatGallons = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '—'
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n)
}
